// Детали отзыва пользователя (kind = feedback, data_service/services/feedback.py): текст целиком,
// куда ответить (почта, Telegram, контакт из формы) и технические данные
import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { CARD_LABEL_COLOR, DIVIDER_COLOR, MUTED_TEXT_COLOR } from '../../styles/tokens';

const TYPE_TITLES = { problem: 'Проблема', idea: 'Идея', question: 'Вопрос' };
const CONTEXT_TITLES = { version: 'Версия', platform: 'Где', screen: 'Экран', device: 'Устройство' };
const linkSx = { color: '#64b5f6', wordBreak: 'break-all' };

export function feedbackRows(payload) {
  const contact = payload.contact || {};
  const context = payload.context || {};
  const reply = [];
  if (contact.email) reply.push({ label: 'Почта', text: contact.email, href: `mailto:${contact.email}` });
  if (contact.telegram) reply.push({ label: 'Telegram', text: contact.telegram, href: contact.telegram_url });
  if (contact.given) reply.push({ label: 'Указал', text: contact.given });
  if (!contact.telegram && contact.telegram_id) reply.push({ label: 'Telegram id', text: String(contact.telegram_id) });

  const details = [];
  if (context.server) details.push({ label: 'Сервер', text: `${context.server.name || context.server.key} (${context.server.key})` });
  Object.entries(CONTEXT_TITLES).forEach(([field, label]) => {
    if (context[field]) details.push({ label, text: context[field] });
  });
  return { reply, details };
}

function Rows({ title, rows, empty }) {
  return (
    <Box>
      <Typography sx={{ fontSize: '13px', color: MUTED_TEXT_COLOR, mb: 0.5 }}>{title}</Typography>
      {rows.length === 0 ? (
        <Typography sx={{ fontSize: '14px', color: CARD_LABEL_COLOR }}>{empty}</Typography>
      ) : (
        <Box component="dl" sx={{ m: 0, display: 'grid', gridTemplateColumns: 'auto minmax(0, 1fr)', columnGap: 1.5, rowGap: 0.5 }}>
          {rows.map((row) => (
            <React.Fragment key={row.label}>
              <Typography component="dt" sx={{ fontSize: '14px', color: CARD_LABEL_COLOR }}>{row.label}</Typography>
              <Typography component="dd" sx={{ m: 0, fontSize: '14px', color: '#e4e4e7', wordBreak: 'break-word' }}>
                {row.href ? (
                  <Link href={row.href} target="_blank" rel="noopener noreferrer" sx={linkSx}>{row.text}</Link>
                ) : (
                  row.text
                )}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default function FeedbackDetails({ item }) {
  const payload = item.payload || {};
  const { reply, details } = feedbackRows(payload);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {TYPE_TITLES[payload.type] && (
        <Typography sx={{ fontSize: '13px', color: MUTED_TEXT_COLOR }}>{TYPE_TITLES[payload.type]}</Typography>
      )}
      <Typography sx={{ fontSize: '15px', color: '#f5f5f5', whiteSpace: 'pre-wrap', wordBreak: 'break-word', mt: -1 }}>
        {payload.text || item.body}
      </Typography>
      <Box sx={{ borderTop: `1px solid ${DIVIDER_COLOR}`, pt: 1.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Rows title="Ответить" rows={reply} empty="Контакта нет" />
        {details.length > 0 && <Rows title="Технические данные" rows={details} />}
      </Box>
    </Box>
  );
}
